import React from 'react';

const PageShell = ({ title, subtitle, className, children }) => (
    <div className={`page-shell ${className || ''}`.trim()}>
        {(title || subtitle) && (
            <header className="page-header">
                {title && <h1 className="page-title">{title}</h1>}
                {subtitle && <p className="page-subtitle">{subtitle}</p>}
            </header>
        )}
        <div className="page-body">{children}</div>
    </div>
);

export default PageShell;
